
import React, { Suspense, useRef } from "react";
import useFirstViewportEntry from "./useFirstViewportEntry";

const RenderonViewportEntry = ({
  children,
  threshold = 0, // default for Intersection Observer
  root = null, // default for Intersection Observer
  rootMargin = "0px 0px 0px 0px", // default for Intersection Observer
  ...wrapperDivProps // For the div rendered below
}) => {
  const ref = useRef();
  const entered = useFirstViewportEntry(ref, { threshold, root, rootMargin });
  return (
    <div {...wrapperDivProps} style = {{minHeight : "20px", margin: 0}} ref={ref}>
      {entered && <Suspense fallback={null}>{children} </Suspense>} </div>
  );
}

export default RenderonViewportEntry


// WEBPACK FOOTER //
// ./src/components/RenderOnViewportEntry/RenderOnViewportEntry.jsx